import styled from 'styled-components';

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
`;

export default PaginationContainer;
